import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalEditarSubgrupo({ currentPage }) {
    const { EditarSubgrupo, EdicaoSubgrupo, setEdicaoSubgrupo, setModalEditarSubgrupo, Grupos, ListaGrupo, setError } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [grupoKey, setGrupoKey] = useState(EdicaoSubgrupo?.grupo.key)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoSubgrupo.descricao) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarSubgrupo(grupoKey, currentPage)
            .then(() => {
                setModalEditarSubgrupo(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoSubgrupo({ ...EdicaoSubgrupo, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaGrupo()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar subgrupo</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarSubgrupo(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoSubgrupo.descricao} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Grupo</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={(e) => setGrupoKey(e.target.value)} name="grupoKey">
                                        <option value="0">Selecione</option>
                                        {Grupos && Grupos.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                            return (
                                                <option key={item.id} value={item.key} selected={item.key == EdicaoSubgrupo?.grupo.key ? true : false}>
                                                    {item.descricao}
                                                </option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarSubgrupo(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarSubgrupo